<!--suppress InconsistentLineSeparators -->
<template>
    <VueWebCam
        :autoplay="true"
        :selectFirstDevice="true"
        class="m-camera-video camera-video"
        width="100%"
        height="auto"
        @error="onError"
        @notsuported="onError"
    />
</template>

<script>

import VueWebCam from "@/components/external/vue-web-cam/webcam";

export default {
    name: "MCameraVideo",
    components: {VueWebCam},
    methods:{
        onError(error){
            console.error('Camera error: '+error);
        },
    }

}
</script>

<style lang="scss">
@import "m-camera-video";
</style>
